<div *ngIf="showMe">
    <tds-modal show="true" (tdsClose)="closeDialog()" header="System Admin Tools" size="md">
        <span slot="body">
            <tds-folder-tabs *ngIf="isSysAdmin()">
                <tds-folder-tab>
                    <button (click)="showThis('sysadmin-set-infomsg')">Set Info Message</button>
                </tds-folder-tab>
                <tds-folder-tab>
                    <button (click)="showThis('sysadmin-give-dispensation')">Give Dispensation</button>
                </tds-folder-tab>
                <tds-folder-tab>
                    <button (click)="showThis('sysadmin-edit-role')">Edit Roles</button>
                </tds-folder-tab>
            </tds-folder-tabs>

            <div>
                <div *ngIf="visiblePage === 'sysadmin-set-infomsg' && isSysAdmin()">
                    <sysadmin-set-infomsg></sysadmin-set-infomsg>
                </div>
                <div *ngIf="visiblePage === 'sysadmin-give-dispensation' && isSysAdmin()">
                    <sysadmin-give-dispensation></sysadmin-give-dispensation>
                </div>
                <div *ngIf="visiblePage === 'sysadmin-edit-role' && isSysAdmin()">
                    <sysadmin-edit-role></sysadmin-edit-role>
                </div>
            </div>
        </span>

        <span slot="actions">
            <tds-button
                data-dismiss-modal
                type="button"
                variant="primary"
                size="md"
                text="Close">
            </tds-button>
        </span>
    </tds-modal>
</div>
